const clamp = (c) => Math.max(0, Math.min(255, c));
const toHex = (r, g, b) => `#${[r, g, b].map((c) => clamp(Math.round(c)).toString(16).padStart(2, '0')).join('')}`;
const toRgb = (hex) => {
  const num = parseInt(hex.replace('#', ''), 16);
  return [(num >> 16) & 0xff, (num >> 8) & 0xff, num & 0xff];
};

// Mixes hex toward black by `amount` (0-1) — same math as this codebase's
// existing color-mix(in srgb, X <100-amount*100>%, black) convention.
// Default 0.15 matches the danger button's hover shade (Components/ui/Button);
// --color-primary-deep uses 0.75 (a much heavier darken, sized against the
// real celeste→escuro luminance ratio) and --color-primary-deep-2 uses 0.6.
export const darkenHex = (hex, amount = 0.15) => {
  const [r, g, b] = toRgb(hex);
  const factor = 1 - amount;
  return toHex(r * factor, g * factor, b * factor);
};

// Mixes hex toward white by `amount` (0-1) — the accent/highlight counterpart
// to darkenHex, used for --color-primary-accent's automatic derivation.
export const lightenHex = (hex, amount = 0.35) => {
  const [r, g, b] = toRgb(hex);
  return toHex(r + (255 - r) * amount, g + (255 - g) * amount, b + (255 - b) * amount);
};

// The 4 hybrid-token companion properties, computed together from the same
// real primaryColor everywhere it's set — shared by every branding-effect call
// site (Authenticated/index.jsx, Settings/Branding, VendorAssessmentForm,
// TransparencyCenter/Public) so a future 5th derived token only needs adding
// here once, not re-duplicated at each of those 4 places (a real bug this
// session: TransparencyCenter/Public's own effect was first written without
// -strong, caught only by live testing against a real branded tenant).
export const applyPrimaryColorVars = (root, primaryColor) => {
  root.style.setProperty('--color-primary', primaryColor);
  root.style.setProperty('--color-primary-strong', darkenHex(primaryColor, 0.15));
  root.style.setProperty('--color-primary-accent', lightenHex(primaryColor, 0.35));
  root.style.setProperty('--color-primary-deep', darkenHex(primaryColor, 0.75));
  root.style.setProperty('--color-primary-deep-2', darkenHex(primaryColor, 0.6));
};

export const clearPrimaryColorVars = (root) => {
  root.style.removeProperty('--color-primary');
  root.style.removeProperty('--color-primary-strong');
  root.style.removeProperty('--color-primary-accent');
  root.style.removeProperty('--color-primary-deep');
  root.style.removeProperty('--color-primary-deep-2');
};
